import React from 'react'

import {
  GridListHeaderContainer,
  GridListHeaderItemCount,
  GridListHeaderTitle,
} from './styled-components'

type Props = {
  itemCount: number
  title?: string
  itemType?: string
}
const GridListHeaderComp = (props: Props) => (
  <GridListHeaderContainer>
    <GridListHeaderTitle>{props.title}</GridListHeaderTitle>
    <GridListHeaderItemCount>
      {props.itemCount + ' ' + props.itemType}
    </GridListHeaderItemCount>
  </GridListHeaderContainer>
)

export default GridListHeaderComp
